export default __webpack_public_path__ + "static/media/martin_carola.e537a841.jpg";